import * as React from 'react';
import * as Styled from './styled';

interface OwnProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  adaptiveModal?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  isBgColor?: boolean;
  isHeaderAbove?: boolean;
  bgImage?: string;
  closeTimeoutMS?: number;
  borderRValue?: number;
  topPosition?: number;
  ariaHideApp?: boolean;
}

interface HeaderProps {
  title?: string;
  onClose?: () => void;
}

const Close: ReactFCWithChildren<JSX.IntrinsicElements['button']> = ({ onClick }) => {
  return (
    <Styled.CloseButton onClick={onClick}>
      <Styled.CrossIcon />
    </Styled.CloseButton>
  );
};

const Header: ReactFCWithChildren<React.PropsWithChildren<HeaderProps>> = ({
  title,
  onClose,
  children,
}) => (
  <Styled.Header>
    {children}
    {title && <Styled.Title>{title}</Styled.Title>}
    {onClose && <Close onClick={onClose} />}
  </Styled.Header>
);

interface Modal extends ReactFCWithChildren<React.PropsWithChildren<OwnProps>> {
  Header: typeof Header;
  Content: typeof Styled.Content;
  ContentWithScroll: typeof Styled.ContentWithScroll;
  Footer: typeof Styled.Footer;
}

const Modal: Modal = ({
  children,
  isOpen,
  onClose,
  className,
  adaptiveModal,
  shouldCloseOnOverlayClick = true,
  isBgColor = true,
  isHeaderAbove = false,
  bgImage = '',
  closeTimeoutMS,
  borderRValue,
  topPosition,
  ariaHideApp = false,
}) => {
  return (
    <Styled.Modal
      className={className}
      isOpen={isOpen}
      onRequestClose={onClose}
      adaptiveModal={adaptiveModal}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      isBgColor={isBgColor}
      bgImage={bgImage}
      isHeaderAbove={isHeaderAbove}
      closeTimeoutMS={closeTimeoutMS}
      borderRValue={borderRValue}
      topPosition={topPosition}
      ariaHideApp={ariaHideApp}
    >
      {children}
    </Styled.Modal>
  );
};

Modal.Header = Header;
Modal.Content = Styled.Content;
Modal.ContentWithScroll = Styled.ContentWithScroll;
Modal.Footer = Styled.Footer;

export default Modal;
